<template>
  <v-dialog v-model="show" @keydown="keyDown" persistent width="500">
    <v-card>
      <v-card-title>
        {{ $t('queues.redirect.title') }}
      </v-card-title>
      <v-card-subtitle class="mt-0">
        {{ $t('queues.redirect.subtitle', { name: call.callerName, num: call.callerNum }) }}
      </v-card-subtitle>
      <v-card-text>
        <v-radio-group v-model="callOpt">
          <v-radio :value="PICKUP" :disabled="!canRedirectToSelf"
            :label="$t('queues.redirect.lblPickup')">
          </v-radio>

          <v-radio :value="REDIRECT" :disabled="!canRedirectToUser"
            :label="$t('queues.redirect.lblRedirect')">
          </v-radio>
            <v-autocomplete v-model="dest" class="ml-8"
              :disabled="callOpt!=REDIRECT"
              :label="$t('queues.redirect.lblDest')"
              :placeholder="$t('queues.redirect.lblPlacehdr')"
              :search-input.sync="search"
              :items="list"
              :error-messages="error"
              auto-select-first
              outlined
              hide-no-data
              clearable
              return-object
              :loading="loading">
            </v-autocomplete>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="cancel">{{ $t('queues.redirect.btnCancel') }}</v-btn>
        <v-btn @click="action">{{ btnText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import events from 'Store/events'
import API from '@/api'
import * as RMQClient from '@/rmqclient'

export default {
  name: 'queue-call-redirect',
  data () {
    return {
      callOpt: 1,
      error: '',
      dest: null,
      search: null,
      list: [],
      loading: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    call: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (!this.canRedirectToSelf) {
      this.callOpt = this.REDIRECT
    }
  },
  watch: {
    search: function (val) {
      if (!val || val.length < 0) return
      this.error = ''
      this.searchList(val)
    },
    callOpt: function () {
      this.error = ''
    }
  },
  computed: {
    ...mapGetters({
      sipuaExten: 'sipuaExten',
      canRedirectToSelf: 'permissions/canQCallRedirSelf',
      canRedirectToUser: 'permissions/canQCallRedirUser'
    }),
    PICKUP: () => 1,
    REDIRECT: () => 2,
    btnText: function () {
      return this.callOpt === this.PICKUP
        ? this.$t('queues.redirect.btnPickup')
        : this.$t('queues.redirect.btnRedir')
    }
  },
  methods: {
    searchList: function (val) {
      this.loading = true
      API.getPanelUsers(0, 10, val).then(resp => {
        this.list.splice(0)
        resp.data.data.forEach(item => {
          this.list.push({
            value: item.exten,
            text: `${item.name} <${item.exten}>`
          })
        })
      }).catch(err => {
        this.dbg(err)
        this.dbg(err.response)
        const msg = API.getException(err) ||
          'Failed to load destinations list from API'
        events.pubError(msg)
      }).finally(() => {
        this.loading = false
      })
    },
    keyDown: function (keydown) {
      switch (keydown.key) {
        case 'Enter':
          this.action()
          break
        case 'Escape':
          this.cancel()
          break
        default:
          this.dbg(`ignore key "${keydown.key}"`)
          break
      }
    },
    cancel: function () {
      this.$emit('cancel')
    },
    action: function () {
      if (this.callOpt === this.REDIRECT) {
        this.redirect()
      } else {
        this.pickup()
      }
    },
    redirect: function () {
      if (!this.dest) {
        this.error = this.$t('queues.redirect.destError')
        return
      }
      this.chanRedirAMICmd(this.dest.value, this.call.channel)
      const from = this.call.callerName
        ? `"${this.call.callerName}" <${this.call.callerNum}>`
        : `"${this.call.callerNum}"`
      events.pubNotify({
        text: 'queues.redirect.successRedir',
        args: { from: from, to: this.dest.text },
        status: 'success'
      })
      this.cancel()
    },
    pickup: function () {
      this.chanRedirAMICmd(this.sipuaExten, this.call.channel)
      events.pubNotify({
        text: 'queues.redirect.pickupReqSent',
        status: 'success'
      })
      this.cancel()
    },
    chanRedirAMICmd: function (dest, chan) {
      const cmd = {
        action: 'Redirect',
        channel: chan,
        exten: dest,
        context: 'default',
        priority: 1,
        amictx: 'queue'
      }
      this.dbg('AMI command: %o', cmd)
      RMQClient.sendCmd(cmd)
    }
  }
}
</script>

<style scoped>
</style>
